
import ko from 'rgs-knockout';

const Model = require('./js/model');
const template = require('./templates/control.html');


ko.components.register('fio-input', {
	viewModel: Model,
	template: template(),
});

